exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3Wl8CPsd3dvWeIZQMjmNax{width:236px}._3pV6jlPpstEw8vwijkbopn{color:\"[theme:themePrimary, default:#0078D4]\"}html[dir=ltr] .J1IgQyNQIrWCZbSRFQqq3{padding-right:30px}html[dir=rtl] .J1IgQyNQIrWCZbSRFQqq3{padding-left:30px}", ""]);
// Exports
exports.locals = {
	"fixWidthContextMenu": "_3Wl8CPsd3dvWeIZQMjmNax",
	"unscheduleText": "_3pV6jlPpstEw8vwijkbopn",
	"footerRight": "J1IgQyNQIrWCZbSRFQqq3"
};